import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { pipe } from 'commity-rehook-fork';
import * as PropTypes from 'prop-types';
import React from 'react';
import { withStylesAsClasses } from '../../../../rehooks';
import { ChoicesList } from '../choices/ChoicesList';

const styles = () => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  notice: {
    alignSelf: 'center',
    fontStyle: 'italic',
    cursor: 'default',
  },
});

const GenderQuestionFormPure = ({
  item,
  translationItem,
  translationPath,
  classes,
  modelPath,
  config,
  readOnly,
  ...others
}) => {
  return (
    <div {...others} className={classNames(classes.root, others.className)}>
      <ChoicesList
        modelPath={modelPath}
        item={item}
        choicesTranslations={translationItem && translationItem.choices}
        translationPath={translationPath}
        config={config}
        readOnly={readOnly}
      />
      <Typography variant="caption" className={classes.notice}>
        notice: Gender question will display image of male/female...
      </Typography>
    </div>
  );
};

export const GenderQuestionForm = pipe(
  withStylesAsClasses(styles),
  GenderQuestionFormPure
);

GenderQuestionForm.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
  }),
  modelPath: PropTypes.array.isRequired,
  translationPath: PropTypes.array.isRequired,
  config: PropTypes.shape({
    addChoice: PropTypes.bool,
    deleteChoice: PropTypes.bool,
  }),
  readOnly: PropTypes.bool,
};
